import React from 'react';

/**
 * LIFF app context: set once after check-identity.
 * Any page can read accessToken / shopId / customer without prop drilling.
 */
const LiffContext = React.createContext(null);

export default LiffContext;
